export const createHealthCardMasterFields = [
  {
    name: "card_name",
    label: "Card Name",
    type: "text",
        placeholder: "Eg. Gold Health Card",

    required: true,
    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },
  {
    name: "price",
    label: "Card Price (₹)",
        placeholder: "Eg. 2399",

    type: "number",
    required: true,
    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },

  {
    name: "status",
    label: "Status",
    type: "select",
    required: true,

    colSpan: {
      base: 6,
      sm: 4,
      md: 2,
      lg: 1,
    },
    options: [
      { value: "active", label: "Active" },
      { value: "inactive", label: "InActive" },
    ],
  },

  {
    name: "duration",
    label: "Duration",
    type: "select",
    required: true,

    colSpan: {
      base: 6,
      sm: 4,
      md: 2,
      lg: 1,
    },
    options: [
      { value: "12", label: "12" },
      { value: "24", label: "24" },
    ],
  },
];
